module.exports = __webpack_public_path__ + "img/percentage.8cf4d506.svg";